module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderfail-container"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-data"
  }, [_c('span', {
    staticClass: "tipimg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/failed.png")
    }
  })]), _c('span', {
    staticClass: "tiptext"
  }, [_vm._v("抱歉，当前网络拥堵，请稍后重试")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3a98d3fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderFail.vue
// module id = 192
// module chunks = 1